import { Validators } from './types';

/**
 * Lower the number, higher the priority of the validator
 */
export default {
  isEmail: 1,
  isPhone: 1,
  isRequired: 0,
} as Record<Validators, number>;
